import { render, staticRenderFns } from "./quotaLog.vue?vue&type=template&id=e754a2b6&scoped=true"
import script from "./quotaLog.vue?vue&type=script&lang=js"
export * from "./quotaLog.vue?vue&type=script&lang=js"
import style0 from "./quotaLog.vue?vue&type=style&index=0&id=e754a2b6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e754a2b6",
  null
  
)

export default component.exports